import React from "react";
import { Helmet } from "react-helmet-async";

const Policies = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-200">
      <Helmet>
        <title>Policies & GDPR Compliance | SeguraTech</title>
        <meta
          name="description"
          content="View SeguraTech’s GDPR, data protection, and compliance policies, including privacy, data retention, and breach response documentation."
        />
      </Helmet>

      <h1 className="text-3xl font-semibold text-[#C6A564] mb-6">
        Policies and Compliance
      </h1>

      <p className="mb-8 text-gray-300">
        SeguraTech Ltd is committed to operating transparently and in full
        compliance with UK GDPR, the Data Protection Act 2018, and recognised
        data security best practice. The following policies and procedures are
        available for public review.
      </p>

      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-medium text-[#C6A564] mb-2">
            Data Protection
          </h2>

          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>
              <a
                href="/legal/compliance/privacy-policy.pdf"
                data-snap-ignore
                className="text-[#C6A564] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </li>

            <li>
              <a
                href="/legal/compliance/data-subject-rights-procedure.pdf"
                data-snap-ignore
                className="text-[#C6A564] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Data Subject Rights Procedure
              </a>
            </li>

            <li>
              <a
                href="/legal/compliance/data-retention-and-deletion-policy.pdf"
                data-snap-ignore
                className="text-[#C6A564] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Data Retention and Deletion Policy
              </a>
            </li>

            <li>
              <a
                href="/legal/compliance/data-breach-response-plan.pdf"
                data-snap-ignore
                className="text-[#C6A564] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Data Breach Response Plan
              </a>
            </li>
          </ul>
        </div>

        {/* Cookies section */}
        <div>
          <h2 className="text-xl font-medium text-[#C6A564] mb-2">
            Cookies
          </h2>

          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>
              <a
                href="/legal/compliance/Cookie%20Policy.pdf"
                data-snap-ignore
                className="text-[#C6A564] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cookie Policy
              </a>
            </li>

            <li>
              <a
                href="/legal/compliance/Cookie%20Consent.pdf"
                data-snap-ignore
                className="text-[#C6A564] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cookie Consent & Tracking Record
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-medium text-[#C6A564] mb-2">
            Future Policies
          </h2>
          <p className="text-gray-300">
            Additional policies will be added here as SeguraTech continues to
            develop its services and compliance framework.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Policies;
